module.exports = __webpack_public_path__ + "static/media/small-logo.57bb9be7.png";